import React, { useEffect, useState } from 'react';
import { getPathLanguage } from '../../../utils/params';
import { useLocation, useParams } from 'react-router-dom';
import { getLanguage, getQueryString } from '../../../utils/params';
import { BreadcrumbSearchResult, BannerSearch, ProjectList, Map } from '../common';
// import { SearchProperties, ErrorSearchProperties } from 'assets/images/icon';
import { SearchProperties } from 'assets/images/icon';
import { fetchFeaturedProjects, fetchAllProjects } from '../searchResult.api';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { useTranslation } from 'react-i18next';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

const SearchPropertiesAndMapComponent = () => {
  const language = getLanguage(useLocation());
  const pathLanguage = getPathLanguage(useLocation());
  const params = useParams();
  // const location = useLocation();
  const [featuredProjects, setFeaturedProjects] = useState('');
  const [allfeaturedProjects, setallFeaturedProjects] = useState('');
  const [centerMap, setCenterMap] = useState({ lat: 21.02828, lng: 105.853882 });
  const [options, setOptions] = useState([]);
  const [zoom, setZoom] = useState(5);
  const { t } = useTranslation();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const cityId = localStorage.getItem('LOCATION_CITY')
    ? localStorage.getItem('LOCATION_CITY')
    : localStorage.getItem('DEFAULT_CITY');
  const headerContent = {
    id: 1,
    imageUrl: 'uploads/for_owner_categories/Rectangle-951.png',
    title: t('search_property.find_properties'),
  };
  const urlFindProperty = params.category !== 'by-property' && params.category !== 'by-map';

  if (params.category && urlFindProperty) {
    window.location.href = pathLanguage + '/find-property/by-property';
  }

  const handlerSearch = e => {
    setCenterMap({ lat: e[0]?.latitude, lng: e[0]?.longitude });
    setZoom(18);
  };

  useEffect(() => {
    showLoader();
    if (params.category === 'by-property') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      document.getElementById('myMap').scrollIntoView();
    }
    Promise.all([
      fetchFeaturedProjects(getQueryString({ language, cityId, pageSize: 15, pageIndex: 1 })),
      fetchAllProjects(getQueryString({ language })),
    ]).then(values => {
      if (values) {
        setFeaturedProjects(values[0]);
        setallFeaturedProjects(values[1]);
        let listOptions = values[1];
        listOptions.forEach(element => {
          element.label = element.projectName;
        });
        setOptions(listOptions);
      }
      hideLoader();
    });
    //eslint-disable-next-line
  }, [language, cityId, params.category]);

  return (
    <>
      <React.Fragment>
        <div id="serviceApartment">
          <BreadcrumbSearchResult />
        </div>
        <BannerSearch content={headerContent} />
        <div className="user-rating-review my-5">
          <div className="container">
            <div className="page-for-owners">
              <div className="row">
                <div className="col-12">
                  <h1 className="detail-apartment-title my-0">{t('search_property.properties')}</h1>
                </div>
                <div className="col-6 form-group mt-3" id="search-by-map">
                  {/* <div className="message-error-search-propetyties mb-2 pb-1">
                    <img src={ErrorSearchProperties} alt="icon-error" />{t('search_property.message_input_search')}
                  </div> */}

                  <div className="position-relative">
                    {/* <input type="text" onClick={handlerSearch} className="form-control padding-left-input-propery" placeholder={t('search_property.fill_project_name')} /> */}
                    <Typeahead
                      id="pagination-example"
                      onPaginate={() => {}}
                      options={options}
                      paginate={true}
                      placeholder={t('search_property.fill_project_name')}
                      onChange={e => handlerSearch(e)}
                      emptyLabel={t('search_property.message_input_search')}
                    />
                    <img
                      className="position-icon-search-property"
                      src={SearchProperties}
                      alt="icon-search-properties"
                    />
                  </div>
                </div>
              </div>
              <Map allProjects={allfeaturedProjects} defaultCenter={centerMap} zoom={zoom} />
              <ProjectList projectList={featuredProjects.items} category={params.category} />
            </div>
          </div>
        </div>
        {loader}
      </React.Fragment>
    </>
  );
};

export default SearchPropertiesAndMapComponent;
